import(/* webpackMode: "eager" */ "/opt/cal.com/apps/web/app/(use-page-wrapper)/(main-nav)/availability/error.tsx");
